// extracted by mini-css-extract-plugin
export var modal = "_gy-0";